import { useEffect } from 'react'
import urljoin from 'url-join'

import { useRouter } from 'next/router'
import useTranslation from '../../modules/i18n/useTranslation'

const LocaleRedirect = ({ to }) => {
  const router = useRouter()
  const { locale } = useTranslation()
  useEffect(() => {
    console.log(router)
    router.push(urljoin(`/${locale}`, to))
  }, [])
  return null
}

export default LocaleRedirect

export const useLocaleRedirect = () => {
  const router = useRouter()
  const { locale } = useTranslation()

  return (to) => {
    router.push(urljoin(`/${locale}`, to))
  }
}
